import * as types from './actionTypes';  
import messageListApi from '../api/messageListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doMessageList() {

  return {
    type: types.DO_MESSAGE_LIST, 
    
  };
}

export function doMessageListRes(data) {  
  return {
    type: types.DO_MESSAGE_LIST_RES, 
    data
  };
}

export function fetchMessageList() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      messageListApi.doMessageList().then(data => {
        dispatch(doMessageListRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}